import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Popover from 'material-ui/Popover/Popover';
import KeyboardArrowDownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import IconTextButton from './IconTextButton';

interface DropdownProps extends React.Props<Dropdown> {
    Icon: React.ReactElement<__MaterialUI.SvgIconProps>;
    text: string;
    style?: React.CSSProperties;
    popoverChildrenStyle?: React.CSSProperties;
    isSmart?: boolean;
    isExpanded?: boolean;
    dataTestId?: string;
    showArrow?: boolean;
    anchorOrigin?: any;
    targetOrigin?: any;
    useAlternativeColors?: boolean;
    isSecondary?: boolean;
    onOpen?(event: React.SyntheticEvent<{}>): any;
    onClose?(reason: string): any;
}

interface DropdownState {
    isExpanded: boolean;
    anchor: HTMLElement;
}

export default class Dropdown extends React.Component<DropdownProps, DropdownState> {
    static defaultProps = {
        showArrow: true,
        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
        targetOrigin: { vertical: 'top',    horizontal: 'left' }
    };

    private button: IconTextButton;

    constructor(props: DropdownProps) {
        super(props);
        this.state = { isExpanded: props.isExpanded, anchor: null };
    }

    componentDidMount() {
        const state = {} as DropdownState;
        state.anchor = ReactDOM.findDOMNode(this.button) as HTMLElement;
        this.setState(state);
    }

    render() {
        const styles = this.getStyles();
        const {Icon, text, isSmart, showArrow} = this.props;
        return (
            <div style={Object.assign({}, styles.root, this.props.style)}>
                <IconTextButton
                    style={styles.button}
                    ref={(ref: IconTextButton) => this.button = ref}
                    Icon={Icon}
                    AdditionalIcon={showArrow && KeyboardArrowDownIcon}
                    text={text}
                    dataTestId={this.props.dataTestId}
                    isPressed={isSmart ? this.state.isExpanded : this.props.isExpanded}
                    onTouchTap={this.onOpen}
                    useAlternativeColors={!!this.props.useAlternativeColors}
                    isSecondary={this.props.isSecondary}
                />

                <Popover
                    open={this.props.isSmart ? this.state.isExpanded : this.props.isExpanded}
                    anchorEl={this.state.anchor}
                    onRequestClose={this.onClose}
                    style={styles.popover}
                    canAutoPosition={false}
                    autoCloseWhenOffScreen={false}
                    anchorOrigin={this.props.anchorOrigin}
                    targetOrigin={this.props.targetOrigin}
                    zDepth={5}
                >
                    <div style={Object.assign({}, styles.popoverChildren, this.props.popoverChildrenStyle)}>
                        {this.props.children}
                    </div>
                </Popover>
            </div>
        );
    }

    private getStyles() {
        return {
            root: {
                display: 'inline-block',
                margin: '0 2px'
            },
            button: {
                display: 'block'
            },
            popover: {
                marginTop: 3,
            },
            popoverChildren: {
                padding: '4px 8px'
            }
        };
    }

    private onOpen = (event: React.SyntheticEvent<{}>) => {
        if (this.props.isSmart) {
            if (this.state.isExpanded) {
                return;
            }
            const newState = {} as DropdownState;
            newState.isExpanded = true;
            this.setState(newState, () => {
                if (this.props.onOpen) {
                    this.props.onOpen(event);
                }
            });
        } else {
            if (this.props.onOpen) {
                this.props.onOpen(event);
            }
        }
    };

    private onClose = (reason: string) => {
        if (this.props.isSmart) {
            if (!this.state.isExpanded) {
                return;
            }
            const newState = {} as DropdownState;
            newState.isExpanded = false;
            this.setState(newState, () => {
                if (this.props.onClose) {
                    this.props.onClose(reason);
                }
            });
        } else {
            if (this.props.onClose) {
                this.props.onClose(reason);
            }
        }
    };
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/custom-components/icon-text-button/Dropdown.tsx
 **/